import { Injectable } from '@angular/core';
import { generateClient, GraphQLQuery, GraphQLSubscription } from '@aws-amplify/api';
import type { GraphQLVariablesV6 } from '@aws-amplify/api-graphql';
import { DocumentNode } from 'graphql';
import { UserManagementService } from './user-management.service';

type OperationVariables = Record<string, any>;

@Injectable({ providedIn: 'root' })
export class ApiService {
  private graphQlApiClient = generateClient();

  constructor(private userManagementService: UserManagementService) {}

  query<TData = any, TVariables extends OperationVariables = OperationVariables>(
    query: string | DocumentNode,
    variables?: TVariables,
  ) {
    const headers = this.userManagementService.getHeaders();
    return this.graphQlApiClient.graphql<GraphQLQuery<TData>>(
      { query, variables: variables as GraphQLVariablesV6<GraphQLQuery<TData>> },
      { ...headers },
    );
  }

  subscription<TData = any, TVariables extends OperationVariables = OperationVariables>(
    query: string | DocumentNode,
    variables?: TVariables,
  ) {
    return this.graphQlApiClient.graphql<GraphQLSubscription<TData>>({
      query,
      variables: variables as GraphQLVariablesV6<GraphQLSubscription<TData>>,
    });
  }
}
